<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-card-text>
            <v-container>
              <v-layout justify-start wrap py-5>
                <v-flex xs1 pr-10 text-center>
                  <v-icon>mdi-account-plus-outline</v-icon>
                </v-flex>
                <v-flex xs10 sm6 md3 text-left>
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >Add New Students</span>
                </v-flex>
                <v-flex xs6 sm6 md8 lg8>
                  <span
                    style="
                      color: #797979;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >Students List</span
                  >
                </v-flex></v-layout>
              <v-layout justify-start wrap>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-select
                    dense
                    style="font-family: nunitosanssemibold"
                    outlined
                    label="Class"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-select
                    dense
                    style="font-family: nunitosansregular"
                    outlined
                    label="Section"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap>
                <v-flex xs6 sm6 md3 lg2 pl-2>
                  <v-card outlined height="50px" color="#F6F5FF">
                    <v-layout justify-center wrap pt-3>
                      <v-flex xs3>
                        <v-icon style="color: #000000"
                          >mdi-note-text-outline</v-icon
                        >
                      </v-flex>
                      <v-flex xs8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >UPLOAD SHEET
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs6 sm6 md2 text-center pt-2>
                  <span style="color: #8f8f8f; font-family: nunitosansregular"
                    >If Available</span
                  >
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap pt-12>
                <v-flex xs12 pl-2>
                  <span style="color: #000000; font-family: nunitosansbold"
                    >Add Student Information</span
                  >
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="First Name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Last Name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Gender"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="DOB"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Admission Number"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Email"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Contact"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Contact"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 pa-2>
                  <v-text-field
                    class="text"
                    label="Address"
                    outlined
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12 sm7 md5 lg4>
                  <v-card outlined height="50px" color="#F6F5FF">
                    <v-layout justify-center wrap pt-3>
                      <v-flex xs2>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-flex xs12 pa-2>
                <div class="dottedline"></div>
              </v-flex>
              <v-layout justify-start wrap pt-3>
                <v-flex xs12 pa-2>
                  <v-text-field
                    class="text"
                    label="Fathers Name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Contact"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Email"
                    outlined
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12 sm7 md5 lg4>
                  <v-card outlined height="50px" color="#F6F5FF">
                    <v-layout justify-center wrap pt-3>
                      <v-flex xs2>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-flex xs12 pa-2>
                <div class="dottedline"></div>
              </v-flex>
              <v-layout justify-start wrap pt-3>
                <v-flex xs12 pa-2>
                  <v-text-field
                    class="text"
                    label="Mothers Name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Contact"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 pa-2>
                  <v-text-field
                    class="text"
                    label="Email"
                    outlined
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pl-2 pb-5>
                <v-flex xs12 sm7 md5 lg4>
                  <v-card outlined height="50px" color="#F6F5FF">
                    <v-layout justify-center wrap pt-3>
                      <v-flex xs2>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >UPLOAD PROFILE PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap py-8>
                <v-flex xs12 sm6 md4>
                  <v-btn
                    block
                    to="/viewStudent"
                    dark
                    height="50px"
                    color="#9B8DFD"
                  >
                    <span style="font-family: nunitosanssemibold">SUBMIT</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      sideNav: false,
      sideNav2: false,
      sideNav3: false,
      studentList: [],
      page: 1,
      classArray: [],
      items: ["I", "II", "III", "IV", "V", "VI"],
    };
  },
};
</script>
<style>
.text {
  color: #5d5d5d;
  font-family: nunitosansregular;
}
.dottedline {
  border: none;
  border-top: 2px dashed rgb(208, 208, 208);
  color: #8181812f;
  height: 1px;
  width: 100%;
}
</style>